module.exports = __webpack_public_path__ + "img/handshake_p.8e548103.png";